
import { createDynamicSlice } from ".";
import { ReviewThunk } from "../thunks/reviewThunk";

const reviewSlice = createDynamicSlice({
  name: "reviewSlice",
  thunk: ReviewThunk,
  listMode: true,
});

export const ReviewReducer = reviewSlice.reducer